export default __webpack_public_path__ + "static/media/Pause.8ceaa809.svg";